import { ToggleButton } from '@progress/kendo-react-dateinputs';
import { DeltaOutline } from '../../../../../icons/icons';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';

export function DiversionToolbarItem() {
    const show = useAppSelector((x) => x.settings.diversionShowOnMap);
    const dispatch = useAppDispatch();

    return (
        <>
            <ToggleButton
                togglable={true}
                selected={show}
                data-tooltip-bottom
                svgIcon={DeltaOutline}
                title={'Show diversion status icons on map'}
                style={{ width: '27px', height: '27px', padding: '0px' }}
                onClick={() => dispatch(setSetting('diversionShowOnMap', !show))}></ToggleButton>
        </>
    );
}
